import React from 'react'

type Props = {}

const Changelog = (props: Props) => {
  return (
    <div>Changelog</div>
  )
}

export default Changelog